import * as React from 'react';
import { Logger } from '../../utils/Logger';

/**
 * Top component used to catch errors.  Can also be used to display a jsx error element.
 */

interface ReactComponentProps {
  children?: React.ReactElement<unknown>;
}

interface ErrorProps extends ReactComponentProps {
  message?: string;
}

interface ErrorState {
  hasError: boolean;
  error?: Error;
  info?: React.ErrorInfo;
}

export class ErrorCatcher extends React.Component<ErrorProps, ErrorState> {

  public constructor(props: ErrorProps) {
    super(props);
    if (props.message) {
      Logger.warn(this.props.message || '');
    }
    this.state = { hasError: false };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo): void {
    this.setState({ hasError: true, error: error, info: info });
    Logger.error(`Error: ${error.toString()}, Info: ${info.toString()}`);
  }

  public render(): React.ReactNode {
    // TODO: Display something on error https://tfs.tsi.lan/tfs/DefaultCollection/Tableau-Dev/_workitems?id=849134
    if (this.state.hasError) {
      return (
        <div>
          <div>{this.state.error ? this.state.error.message : null}</div>
          <pre>{this.state.info ? this.state.info.componentStack : null}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
